import React, { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { createList } from "../../../../api/ContactAPI";
import { Button, Group, Popover, Stack, TextInput } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";

const CreateEmptyList = ({ onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);
    createList({ name: data.name })
      .then((res) => {
        setOpened(false);
        onFinish?.(res.data.contact_list_id);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Popover opened={opened} onChange={setOpened} withinPortal={false}>
      <Popover.Target>
        <Button
          leftSection={<IconPlus size={18} />}
          size="sm"
          radius={"md"}
          fz={16}
          ml={"auto"}
          mt={4}
          onClick={() => setOpened(true)}
          variant="default"
          mr={"10%"}
          className="bump-stroke test no-shadow"
          style={{
            border: "1px solid var(--mantine-color-primary-0)",
          }}
        >
          {lang.contact_lists.create.empty}
        </Button>
      </Popover.Target>

      <Popover.Dropdown>
        <Stack component={"form"} onSubmit={handleSubmit} w={200}>
          <TextInput
            label={lang.contact_lists.create.dialog.name}
            name="name"
            autoFocus
            required
          />
          <Group wrap="nowrap" justify="end">
            <Button
              size="compact-sm"
              variant="subtle"
              disabled={loading}
              onClick={() => setOpened(false)}
            >
              {lang.components.closer.submit}
            </Button>
            <Button type="submit" loading={loading} size="sm">
              {lang.contact_lists.create.dialog.submit_button}
            </Button>
          </Group>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default CreateEmptyList;
